var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountIssue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "84px",
    height: "84px",
    viewBox: "0 0 84 84",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "telegram\u5907\u4EFD 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iPhone-13\\u5907\\u4EFD",
    transform: "translate(-245.000000, -626.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "telegram\\u5907\\u4EFD-8",
    transform: "translate(245.000000, 626.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#D8D8D8",
    opacity: 0,
    x: 0,
    y: 0,
    width: 84,
    height: 84
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#3E8A57",
    x: 14,
    y: 14,
    width: 56,
    height: 56,
    rx: 10.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.169,45.5 L40.169,59.5 L28.875,59.5 C27.7209154,59.5 26.773227,58.6812463 26.693001,57.6467961 L26.6875,57.5044543 L26.6875,45.5 L40.169,45.5 Z M57.3125,45.5 L57.3125,57.5044543 C57.3125,58.6051225 56.3349609,59.5 55.125,59.5 L55.125,59.5 L43.669,59.5 L43.669,45.5 L57.3125,45.5 Z M33.9370117,24.5822687 C35.6118164,24.2897899 37.3857422,24.7831275 38.934082,25.9671378 C39.7680664,26.601429 40.5268555,27.4189599 41.2036133,28.4056351 C41.6376953,29.0364025 42.550293,29.0364025 42.984375,28.4056351 C43.6611328,27.4189599 44.4199219,26.6049529 45.2539062,25.9671378 C46.8056641,24.7831275 48.5795898,24.2933138 50.2543945,24.5822687 C51.1772461,24.7443653 52.0488281,25.1002732 52.7050781,25.5900869 C53.6176758,26.2737119 54.137207,27.196958 54.2021484,28.2611577 C54.2568359,29.1526892 53.9970703,30.0512685 53.4638672,30.8687994 C53.3408203,31.0555629 53.4707031,31.3092794 53.6894531,31.3092794 L53.6894531,31.3092794 L55.125,31.3092794 C57.5415039,31.3092794 59.5,33.3284397 59.5,35.8197947 L59.5,35.8197947 L59.5,40.33031 C59.5,40.8553621 59.1513672,41.299366 58.6796875,41.4227004 L58.6796875,41.4227004 L43.669,41.422 L43.6690924,35.0350964 L40.1690924,35.0350964 L40.169,41.422 L25.3203125,41.4227004 C24.8879395,41.3096439 24.55896,40.9271359 24.5071326,40.4597458 L24.5,40.33031 L24.5,35.8197947 C24.5,33.3284397 26.4584961,31.3092794 28.875,31.3092794 L28.875,31.3092794 L30.5019531,31.3092794 C30.7241211,31.3092794 30.8505859,31.0555629 30.7275391,30.8687994 C30.190918,30.0512685 29.9345703,29.1526892 29.9892578,28.2611577 C30.0541992,27.1934342 30.5737305,26.2701881 31.4863281,25.5900869 C32.1425781,25.1002732 33.0141602,24.7443653 33.9370117,24.5822687 Z M49.8886719,26.8058117 C48.1762695,26.5062853 45.8725586,27.4894367 44.0541992,30.8899424 C43.9550781,31.0802298 44.0849609,31.3092794 44.293457,31.3092794 L44.293457,31.3092794 L49.0102539,31.3092794 C50.9550781,30.854704 52.0830078,29.4592633 52.0180664,28.4056351 C51.9394531,27.196958 50.097168,26.8410501 49.8886719,26.8058117 Z M40.1337891,30.8899424 C38.3188477,27.4894367 36.0151367,26.5098092 34.2993164,26.8058117 C34.0874023,26.844574 32.2451172,27.196958 32.1699219,28.4056351 C32.1049805,29.4592633 33.2363281,30.8511802 35.1777344,31.3092794 L35.1777344,31.3092794 L39.8945312,31.3092794 C40.1030273,31.3092794 40.2363281,31.0767059 40.1337891,30.8899424 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIssue);
export default __webpack_public_path__ + "static/media/account_issue.311ff4702872d93d7f746f9fed5d40df.svg";
export { ForwardRef as ReactComponent };